{
  "name": "@ns/accept-company-request-to-join",
  "version": "1.0.0",
  "description": "Join the company that invited you to nodeStream.",
  "inputs": {
    "invitationId": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "accept": {}
  }
}
